(() => {
  const setupCards = () => {
    document.querySelectorAll('[data-av-card]').forEach(card => {
      if (card.dataset.avBound) return;
      card.dataset.avBound = 'true';
      card.querySelectorAll('[data-av-swatch]').forEach(swatch => {
        swatch.setAttribute('role', 'button');
        swatch.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          card.querySelectorAll('[data-av-swatch]').forEach(other => other.setAttribute('aria-pressed', String(other === swatch)));
          const image = card.querySelector('.av-card__image');
          if (image && swatch.dataset.image) {
            const source = new URL(swatch.dataset.image, location.href);
            image.srcset = [240, 360, 540, 720, 900].map(width => {
              source.searchParams.set('width', String(width));
              return `${source.href} ${width}w`;
            }).join(', ');
            image.src = swatch.dataset.image;
            image.alt = swatch.dataset.alt || '';
          }
          card.querySelectorAll('[data-av-product-link]').forEach(link => link.href = swatch.href);
          const stock = card.querySelector('[data-av-stock]');
          if (stock) stock.hidden = swatch.dataset.available !== 'true';
          const price = document.getElementById(swatch.dataset.priceId);
          const target = card.querySelector('[data-av-card-price]');
          if (price && target) target.replaceChildren(price.content.cloneNode(true));
        });
        swatch.addEventListener('keydown', event => {
          if (event.key === ' ') { event.preventDefault(); swatch.click(); }
        });
      });
    });
    document.querySelectorAll('#product-grid, .av-product-grid, .product-grid').forEach(grid => {
      const seen = new Set();
      let hiddenCount = 0;
      grid.querySelectorAll('[data-av-family]').forEach(card => {
        const item = card.closest('.grid__item') || card;
        const family = card.dataset.avFamily;
        item.hidden = seen.has(family);
        if (item.hidden) hiddenCount++;
        seen.add(family);
      });
      if (grid.id === 'product-grid' && hiddenCount > 0) {
        const label = grid.dataset.avModelCount;
        const visible = [...grid.querySelectorAll('.av-card')].filter(card => !card.closest('[hidden]')).length;
        if (label) document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(el => {
          const text = label.replace('__COUNT__', String(visible));
          if (el.textContent.trim() !== text) el.textContent = text;
        });
      }
    });
  };
  const updateSticky = () => {
    const buy = document.querySelector('.product-form__submit');
    const sticky = document.querySelector('[data-av-sticky-buy]');
    if (!buy || !sticky) return;
    new IntersectionObserver(entries => {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && window.scrollY > 350);
    }, {threshold: 0}).observe(buy);
    sticky.addEventListener('click', () => {
      buy.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
      buy.focus({preventScroll: true});
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('[data-av-disclosure][open]').forEach(el => {el.open = false; el.querySelector('summary')?.focus();});
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-av-disclosure][open]').forEach(el => {if (!el.contains(event.target)) el.open = false;});
  });
  document.addEventListener('shopify:section:load', setupCards);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {queued = false; setupCards();});
  }).observe(document.getElementById('MainContent'), {childList: true, subtree: true});
  setupCards();
  updateSticky();
})();